import { keys } from "lodash";
import { Dispatch } from "redux";

import { Location, push } from "redux-little-router";

export const navigateToParentRoute = () => {
    return (dispatch: Dispatch, getState: () => { router: Location }) => {
        const router = getState().router;
        const parentRoute: { route: string } = router.routes[(router as { route: string }).route].parent;
        const parentPath = keys(router.params).reduce((path, param) => path.replace(`:${param}`, router.params[param]), parentRoute.route);
        dispatch(push(parentPath));
    };
};
